module.exports = __webpack_public_path__ + "img/luk.54f1b31f.jpg";